export const seasons = [
  {
    "id": "legacy-media-preservation-season",
    "slug": {
      "en": "archive-collection",
      "es": "coleccion-de-archivo",
      "nl": "archiefcollectie",
      "pap": "kolekshon-di-archivo"
    },
    "programId": "legacy-media-archive",
    "seasonNumber": 1,
    "title": {
      "en": "Archive Collection",
      "es": "Coleccion de Archivo",
      "nl": "Archiefcollectie",
      "pap": "Kolekshon di Archivo"
    },
    "question": {
      "en": "Which study material belongs together before deeper sequencing occurs?",
      "es": "Que material de estudio pertenece junto antes de una secuencia mas profunda?",
      "nl": "Welk studiemateriaal hoort bij elkaar voordat diepere ordening plaatsvindt?",
      "pap": "Ki material di estudio ta pertenese huntu prome ku e ordenashon mas profundo?"
    },
    "archetype": "threshold",
    "transformationPurpose": {
      "en": "Make the archive usable for study while keeping final sequencing open.",
      "es": "Hacer que el archivo sea util para el estudio mientras la secuencia final queda abierta.",
      "nl": "Maak het archief bruikbaar voor studie terwijl de definitieve ordening open blijft.",
      "pap": "Hasi e archivo util pa estudio mientras e sekuensia final ta keda habri."
    },
    "description": {
      "en": "Video cards from the public archive, preserved in their current order.",
      "es": "Tarjetas de video del archivo publico, preservadas en su orden actual.",
      "nl": "Videokaarten uit het publieke archief, bewaard in hun huidige volgorde.",
      "pap": "Kartanan di video for di archivo publiko, preserva den nan orden aktual."
    },
    "episodes": [
      "legacy-eigen-pad-s1e1-de-7-principes-voor-een-morele-samenleving-waarheid",
      "legacy-eigen-pad-s1e2-de-7-principes-voor-een-morele-samenleving-gerechtigheid",
      "legacy-eigen-pad-s1e3-de-7-principes-voor-een-morele-samenleving-harmonie",
      "legacy-eigen-pad-s1e4-de-7-principes-voor-een-morele-samenleving-evenwicht",
      "legacy-eigen-pad-s1e5-de-7-principes-voor-een-morele-samenleving-speciale-aflevering-orde-met-uitleg-va",
      "legacy-eigen-pad-s1e6-de-7-principes-voor-een-morele-samenleving-wederkerigheid",
      "legacy-eigen-pad-s1e7-de-7-principes-voor-een-morele-samenleving-fatsoen",
      "legacy-eigen-pad-s1e8-interview-met-matt-landman",
      "legacy-eigen-pad-s2e0-de-matrix-gedecodeerd-promo",
      "legacy-eigen-pad-s2e1-deel-1-de-matrix-gedecodeerd-wat-is-de-matrix",
      "legacy-eigen-pad-s2e2-deel-2-de-matrix-gedecodeerd-wat-is-de-matrix",
      "legacy-eigen-pad-s2e2-5-de-matrix-gedecodeerd-promo",
      "legacy-eigen-pad-s2e3-de-matrix-gedecodeerd-interview-met-marja-west",
      "legacy-eigen-pad-s2e4-de-matrix-gedecodeerd-waarom-zijn-we-in-de-matrix",
      "legacy-eigen-pad-s2e4-5-de-matrix-gedecodeerd-promo",
      "legacy-eigen-pad-s2e5-de-matrix-gedecodeerd-de-illusie-van-normal-interview-met-nicky-rojer",
      "legacy-eigen-pad-s2e6-de-matrix-gedecodeerd-interview-met-marja-west-deel-2",
      "legacy-eigen-pad-s2e7-de-matrix-gedecodeerd-hoe-komen-we-uit-de-matrix",
      "legacy-eigen-pad-s2e8-de-matrix-gedecodeerd-wat-betekent-om-wakker-te-zijn",
      "legacy-eigen-pad-s2e9-de-matrix-gedecodeerd-interview-met-marja-west-deel-3",
      "legacy-eigen-pad-s2e10-deel-1-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel",
      "legacy-eigen-pad-s2e11-deel-2-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel",
      "legacy-eigen-pad-s2e12-de-matrix-gedecodeerd-interview-met-marja-west-deel-4",
      "legacy-eigen-pad-s2e13-de-matrix-gedecodeerd-de-echte-evolutie-interview-met-nicky-rojer",
      "legacy-resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers",
      "legacy-eigen-pad-s3e0-kabbala-and-tarot-onthuld-promo",
      "legacy-het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch",
      "legacy-het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch",
      "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen",
      "legacy-eigen-pad-s3e2-kabbala-and-tarot-onthuld-symbolen-en-realiteit",
      "legacy-eigen-pad-s3e3-kabbala-and-tarot-onthuld-contact-maken-met-de-boven-werelden",
      "legacy-eigen-pad-s3e4-kabbala-and-tarot-onthuld-wie-is-god-deel-1",
      "legacy-eigen-pad-s3e5-kabbala-and-tarot-onthuld-wie-is-god-deel-2",
      "legacy-eigen-pad-s3e6-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-deel-1",
      "legacy-eigen-pad-s3e7-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-mazzaroth-de-zodiac-deel-2",
      "legacy-eigen-pad-s3e8-mazzaroth-de-zodiac",
      "legacy-eigen-pad-s3e9-gilgulim-reincarnatie",
      "legacy-eigen-pad-s3e10-de-hemelen-en-zijn-wezens",
      "legacy-eigen-pad-s3e11-wat-is-de-shekinah-kundalini",
      "legacy-eigen-pad-s3e12-het-zelf-en-het-universum-geopenbaard-in-symbolen-tarot",
      "legacy-eigen-pad-s4e0-de-steeds-opkomende-zo-o-n-promo",
      "legacy-de-onheilige-drie-eenheid-dutch",
      "legacy-eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking",
      "legacy-eigen-pad-s4e2-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "legacy-eigen-pad-s4e3-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "legacy-eigen-pad-s4e4-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "legacy-eigen-pad-s4e5-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "legacy-eigen-pad-s4e6-de-steeds-opkomende-zo-o-n-de-kleine-arcana-staven",
      "legacy-eigen-pad-s4e7-de-steeds-opkomende-zo-o-n-de-kleine-arcana-bekers",
      "legacy-eigen-pad-s4e8-de-steeds-opkomende-zo-o-n-de-kleine-arcana-zwaarden",
      "legacy-eigen-pad-s4e9-de-steeds-opkomende-zo-o-n-de-kleine-arcana-pentakels",
      "legacy-eigen-pad-s4e10-de-steeds-opkomende-zo-o-n-integratie-van-de-grote-en-kleine-arcana",
      "legacy-eigen-pad-s4e11-de-steeds-opkomende-zo-o-n-hebreeuwse-letters-getallen-en-de-kabbalistische-leve",
      "legacy-eigen-pad-s4e12-de-steeds-opkomende-zo-o-n-alchemistische-symboliek-in-tarot-zelftransformatie",
      "legacy-eigen-pad-s4e13-de-steeds-opkomende-zo-o-n-waarzeggerij-kaartenleggingen-en-praktische-toepassin",
      "legacy-eigen-pad-s5e0-de-occulte-kant-van-de-bijbel-promo",
      "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties",
      "legacy-eigen-pad-s5e2-de-occulte-kant-van-de-bijbel-genesis-van-de-schriften",
      "legacy-eigen-pad-s5e3-de-occulte-kant-van-de-bijbel-genesis-t-m-jozua",
      "legacy-eigen-pad-s5e4-de-occulte-kant-van-de-bijbel-jozua-t-m-2-samuel",
      "legacy-eigen-pad-s5e5-de-occulte-kant-van-de-bijbel-1-samuel-t-m-2-kronieken",
      "legacy-eigen-pad-s5e6-de-occulte-kant-van-de-bijbel-jesaja-jeremia-ezechiel-daniel-hosea-t-m-maleachi",
      "legacy-eigen-pad-s5e7-de-occulte-kant-van-de-bijbel-ezra-nehemia-esther-judith-tobit",
      "legacy-eigen-pad-s5e8-de-occulte-kant-van-de-bijbel-1-and-2-makkabeeen",
      "legacy-eigen-pad-s5e9-de-occulte-kant-van-de-bijbel-job-psalmen-spreuken-prediker-hooglied-klaagliedere",
      "legacy-eigen-pad-s5e10-de-occulte-kant-van-de-bijbel-matteus-marcus-lucas-johannes-en-handelingen",
      "legacy-eigen-pad-s5e11-de-occulte-kant-van-de-bijbel-romeinen-korintiers-galaten-efeziers-filippenzen-k",
      "legacy-eigen-pad-s5e12-de-occulte-kant-van-de-bijbel-openbaring",
      "legacy-de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt-en-ordevolgers-slavernij",
      "legacy-eigen-pad-s6e0-het-gilgamesj-epos-promo",
      "legacy-eigen-pad-s6e1-het-gilgamesj-epos-introductie-tijdlijn-en-interpretaties",
      "legacy-eigen-pad-s6e2-het-gilgamesj-epos-tablet-i-het-ego",
      "legacy-eigen-pad-s6e3-het-gilgamesj-epos-tablet-ii-de-schaduw",
      "legacy-eigen-pad-s6e4-het-gilgamesj-epos-tablet-iii-t-m-iv-de-reis",
      "legacy-eigen-pad-s6e5-het-gilgamesj-epos-tablet-v-de-confrontatie",
      "legacy-eigen-pad-s6e6-het-gilgamesj-epos-tablet-vi-verlangen-en-beheersing",
      "legacy-eigen-pad-s6e7-het-gilgamesj-epos-tablet-vii-de-dood",
      "legacy-eigen-pad-s6e8-het-gilgamesj-epos-tablet-viii-t-m-xii-de-zoektocht-en-terugkeer",
      "legacy-pika-pika-talkshow-dikon-e-kosnan-aki-ta-pasa-mi-atrobe",
      "legacy-pika-pika-talkshow-kortamentu-di-orea-i-adulterio",
      "legacy-pika-pika-talkshow-reenkarnashon-ta-eksisti",
      "legacy-pika-pika-talkshow-dikon-mi-no-por-hanja-un-homber-na-drechi",
      "legacy-pika-pika-talkshow-euthanasia",
      "legacy-pika-pika-talkshow-kiko-pabo-ta-sekta-sataniko",
      "legacy-nothing-new-under-the-sun-interviewed-by-jonathan-wright-english",
      "legacy-interviewed-by-axel-dahi-english",
      "legacy-interviewed-by-nicholas-peter-urgero-english",
      "legacy-het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch-2",
      "legacy-het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch-2",
      "legacy-interviewed-by-marja-west-english",
      "legacy-interviewed-by-nathan-crabtree-english",
      "legacy-natuurwet-is-koning-w-glenn-tramm-poppencast-104-dutch",
      "legacy-resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers-2",
      "legacy-echos-of-the-past-why-slavery-persists-exploring-dutch-slave-history-and-why-humanity-resists-ch",
      "legacy-de-onheilige-drie-eenheid-dutch-2",
      "legacy-navigating-power-law-and-the-future-with-axel-dahi",
      "legacy-know-thy-self-podcast-11-with-chris-and-vuk",
      "legacy-know-thy-self-podcast-13-with-chris-and-vuk",
      "legacy-know-thy-self-podcast-15-with-chris-and-vuk",
      "legacy-imposed-architectures-of-government-religion-and-money-ethereal-encounters-unveiled-with-glenn-t",
      "legacy-interview-w-marja-west-university-of-the-ancient-elders-degrees-of-consciousness-episode-423",
      "legacy-de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt-en-ordevolgers-slavernij-2",
      "legacy-season-02-episode-01-het-ego-en-manipulatie-technieken",
      "legacy-season-02-episode-02-oerangsten",
      "legacy-season-02-episode-03-verdeel-and-heers-en-indoctrinatie-technieken",
      "legacy-season-02-ouroboros-the-passing-of-the-blue-crown",
      "legacy-season-02-episode-03-and-189-symbologie",
      "legacy-season-02-episode-04-gecontroleerde-oppositie-techniek",
      "legacy-season-02-episode-04-and-189-de-new-age-beweging",
      "legacy-season-02-de-macht-van-een-echte-koning-in-give-in",
      "legacy-season-02-episode-05-het-monetaire-systeem",
      "legacy-season-02-loop-niet-over-mij-heen-valhalla",
      "legacy-season-02-karmishe-wet-of-niet",
      "legacy-season-02-episode-05-and-189-het-blauwe-envelopje",
      "legacy-season-02-episode-06-massa-media",
      "legacy-season-02-het-niet-agressieprincipe-eternal-light",
      "legacy-season-02-episode-07-voedsel",
      "legacy-season-02-episode-08-medicijn",
      "legacy-season-02-episode-09-de-illusie-van-tijd",
      "legacy-season-02-episode-10-de-dhr-factor",
      "legacy-season-02-de-drie-hoofdculten-dragonborn",
      "legacy-season-02-episode-11-religie-deel-1",
      "legacy-season-02-episode-11-religie-deel-2",
      "legacy-season-02-al-haar-namen-one-forgiven",
      "legacy-season-02-episode-12-deel-1-1-de-egyptische-opwekking",
      "legacy-season-02-episode-13-deel-2-1-de-grote-arcana",
      "legacy-season-02-episode-14-deel-2-2-de-grote-arcana",
      "legacy-season-02-episode-15-deel-2-3-de-grote-arcana",
      "legacy-season-02-episode-16-deel-2-4-de-grote-arcana",
      "legacy-season-02-episode-17-deel-3-1-de-kleine-arcana-staven",
      "legacy-season-02-episode-18-deel-3-2-de-kleine-arcana-bekers",
      "legacy-season-02-episode-19-deel-3-3-de-kleine-arcana-zwaarden",
      "legacy-season-02-episode-20-deel-3-4-de-kleine-arcana-pentakels",
      "legacy-season-02-episode-21-deel-3-5-integratie-van-de-grote-en-kleine-arcana",
      "legacy-season-02-episode-22-deel-3-6-hebreeuwse-letters-getallen-en-de-kabbalistische-levensboom",
      "legacy-season-02-episode-23-deel-3-7-alchemistische-symboliek-in-tarot-zelftransformatie",
      "legacy-season-02-episode-24-deel-3-8-waarzeggerij-kaartenleggingen-en-praktische-toepassing",
      "legacy-season-02-episode-01-het-ego-en-manipulatie-technieken-2",
      "legacy-season-01-episode-00-re-member",
      "legacy-season-01-episode-01-de-alles",
      "legacy-season-01-episode-02-natuur-wetten",
      "legacy-season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad",
      "legacy-season-01-episode-03-goed-en-kwaad",
      "legacy-season-01-episode-03-and-189-aankondiging-van-ware-liefde",
      "legacy-season-01-episode-04-ware-liefde",
      "legacy-season-01-episode-05-het-brein-en-jou-wereldbeeld",
      "legacy-season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden",
      "legacy-season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit",
      "legacy-episode-06-how-to-create-web-page-using-bootstrap-4",
      "legacy-episode-05-how-to-create-web-page-using-bootstrap-4",
      "legacy-episode-04-how-to-create-web-page-using-bootstrap-4",
      "legacy-season-01-episode-00-re-member-2",
      "legacy-season-01-episode-01-de-alles-2",
      "legacy-season-01-episode-02-natuurwetten",
      "legacy-season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad-2",
      "legacy-season-01-episode-03-goed-en-kwaad-2",
      "legacy-season-01-episode-03-and-189-aankondiging-van-ware-liefde-2",
      "legacy-season-01-episode-04-ware-liefde-2",
      "legacy-season-01-episode-05-het-brein-en-jou-wereldbeeld-2",
      "legacy-season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden-2",
      "legacy-season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit-2",
      "legacy-season-01-transformeren-naar-het-goede-closure"
    ],
    "materials": [],
    "gatewayToNextSeason": null
  }
];
